import { createAction } from "@reduxjs/toolkit";
import type { ROLES } from "@user-management-context/shared/domain/types/enums/roles";

export const setActiveRole = createAction<ROLES | null>("auth/setActiveRole");
